import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function CustodyWallet() {
  const [snapshot, setSnapshot] = useState(null);

  const load = async () => {
    try {
      const res = await api.get('/custody/wallet');
      setSnapshot(res.data);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to load custody wallet');
    }
  };

  useEffect(() => { load(); }, []);

  const activate = async () => {
    try {
      await api.post('/custody/wallet/activate');
      toast.success('Custody wallet activated');
      await load();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Wallet activation failed');
    }
  };

  if (!snapshot) {
    return (
      <div className="page-shell page-stack">
        <section className="surface-panel">
          <div className="section-tag">Custody wallet</div>
          <button className="btn btn-primary" onClick={activate}>Activate trading wallet</button>
        </section>
      </div>
    );
  }

  return (
    <div className="page-shell page-stack">
      <section className="surface-panel glow-surface" style={{ padding: '1.5rem' }}>
        <div className="section-tag">Custody wallet</div>
        <h1 className="section-title">{snapshot.wallet.label}</h1>
        <p className="section-copy">{snapshot.wallet.address}</p>
      </section>

      <section className="metric-strip">
        <div className="metric-tile"><div className="eyebrow">Available INR</div><div className="value" style={{ color: 'var(--neon-green)' }}>₹{Number(snapshot.cash.available_inr || 0).toLocaleString('en-IN')}</div></div>
        <div className="metric-tile"><div className="eyebrow">Reserved INR</div><div className="value" style={{ color: 'var(--neon-cyan)' }}>₹{Number(snapshot.cash.reserved_inr || 0).toLocaleString('en-IN')}</div></div>
        <div className="metric-tile"><div className="eyebrow">Pending INR</div><div className="value" style={{ color: 'var(--neon-orange)' }}>₹{Number(snapshot.cash.pending_inr || 0).toLocaleString('en-IN')}</div></div>
      </section>

      <section className="surface-panel" style={{ padding: '1.5rem' }}>
        <div className="section-tag">Token balances</div>
        <div style={{ marginTop: '1rem', display: 'grid', gap: '0.8rem' }}>
          {(snapshot.tokens || []).map((token) => (
            <div key={`${token.wallet_id}-${token.token_class_id}`} className="summary-row">
              <div>
                <div>{token.symbol} · {token.project_name}</div>
                <div className="stat-sub">{token.vintage}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div>Avail {Number(token.available_qty).toLocaleString('en-IN')}</div>
                <div className="stat-sub">Res {Number(token.reserved_qty).toLocaleString('en-IN')} · Ret {Number(token.retired_qty).toLocaleString('en-IN')}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
